import { BudgetQuestionCodes } from './budgetQuestionCodes';

export const questionsWithMinInvoiceAmount = [{
  minInvoiceAmount: 100,
  questionCode: BudgetQuestionCodes.Q15,
}];
